import { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Zoom from "../assets/images/zoom.svg";
import Cancel from "../assets/images/cancel.svg";
import LikeF from "../assets/images/like.svg";
import LikeO from "../assets/images/like2.svg";
import WishlistF from "../assets/images/wishlist.svg";
import WishlistO from "../assets/images/wishlist2.svg";
import Loading from "../assets/images/loading.gif";
import Crown from "../assets/images/crown.svg";
import moment from 'moment';
import Magnifier from "react-magnifier";
import { addToLikeList, addToWishlist, removeFromLikeList, removeFromWishlist, showLoginModal } from "../actions/GalleryActions";
import client from "../utils/client";

const Product = function ({ shirt, userActionsState }) {
  const dispatch = useDispatch();
  const user = useSelector(({ Gallery }) => Gallery?.user);

  const [magnify, setMagnify] = useState(false);
  const [likes, setLikes] = useState(shirt.likes);
  const [tooltipActive, setTooltipActive] = useState(false);
  const [likeLoadingRequest, setLikeLoadingRequest] = useState(false);
  const [wishlistLoadingRequest, setWishlistLoadingRequest] = useState(false);

  const checkIfLoggedIn = () => {
    if (user.status === false) {
      dispatch(showLoginModal(true))
      return false;
    } else {
      return true
    }
  }

  const getImagesVariants = (shirt, type) => {
    const filteredImage = shirt.getImageVariants().filter(image => image.variant === 1 && image.size === type)[0]
    return filteredImage ? filteredImage.image_url : null
  }

  const likeShirt = useCallback(async () => {
    if (!checkIfLoggedIn()) { return }
    try {
      setLikeLoadingRequest(true)
      if (userActionsState.liked?.includes(shirt.id)) {
        await dispatch(removeFromLikeList(shirt.id))
        setLikes((likes) => likes > 0 ? likes - 1 : 0)
      } else {
        await dispatch(addToLikeList(shirt.id))
        setLikes((likes) => likes + 1)
      }
    } finally {
      setLikeLoadingRequest(false)
    }
  },
    [dispatch, userActionsState],
  )

  const wishlistShirt = useCallback(async () => {
    if (!checkIfLoggedIn()) { return }
    try {
      setWishlistLoadingRequest(true)
      if (userActionsState.wishlisted?.includes(shirt.id)) {
        await dispatch(removeFromWishlist(shirt.id));
      } else {
        await dispatch(addToWishlist(shirt.id));
      }
    } finally {
      setWishlistLoadingRequest(false)
    }
  },
    [dispatch, userActionsState],
  )

  const translate = (value) => {
    return value.includes("[[") ? client.tt(value) : value
  }

  return (
    <div className="product">

      <img className="zoom-btn" src={magnify ? Cancel : Zoom} alt="" onClick={() => setMagnify(!magnify)} />

      <div className="product-container">
        <div className="preview">
          {magnify ?
            <picture className="prod-img">
              <Magnifier src={getImagesVariants(shirt, "main")} />
            </picture>
            :
            <picture className="prod-img">
              <source media="(min-width: 600px)" srcSet={getImagesVariants(shirt, "main")} />
              <source media="(max-width: 600px)" srcSet={getImagesVariants(shirt, "mobile")} />
              <img src={shirt.getImageVariants()[0].image_url} alt=""></img>
            </picture>
          }
        </div>

        <div className="details">

          <div className="buy-side">
            <div className="actions">
              <div className="likes-count">{likes}</div>
              {likeLoadingRequest ?
                <img className="like-btn" src={Loading} /> :
                <img className="like-btn" src={userActionsState?.liked && userActionsState?.liked?.includes(shirt.id) ? LikeF : LikeO} alt="" onClick={likeShirt} />
              }
              {
                wishlistLoadingRequest ?
                  <img className="wishlist-btn" src={Loading} /> :
                  <img className="wishlist-btn" src={userActionsState?.wishlisted && userActionsState?.wishlisted?.includes(shirt.id) ? WishlistF : WishlistO} alt="" onClick={wishlistShirt} />
              }
              <div className="sotw-area">
                <div className={"tooltip " + (tooltipActive ? "active" : "")}>
                  <p>Hemd der Woche<br />{moment(shirt.sotw_dates.start).format("DD MMM YYYY")} - {moment(shirt.sotw_dates.end).format("DD MMM YYYY")}</p>
                </div>
                <img className={"sotw-crown " + (shirt.is_sotw ? "" : "hidden")} src={Crown} onClick={() => setTooltipActive(!tooltipActive)} alt="" />
              </div>
            </div>

            {!user.status ?
              <button type="submit" class="buy-btn" onClick={() => checkIfLoggedIn()}>
                Bestellen €{shirt.price.value.toFixed(2)}
              </button>
              :
              <form id={"buy_form_" + shirt.id} action="/shirt_gallery/one_click_purchase.php" method="POST">
                <input type="hidden" name="shirt_order_id" value={shirt.id} />
                <button type="submit" class="buy-btn">
                  Bestellen €{shirt.price.value.toFixed(2)}
                </button>
              </form>
            }
          </div>

        </div>

        <div className="shirt-details">
          <b>{shirt.gender === "man" ? "Maßhemd" : "Maßbluse"}</b><br />
          {shirt.has_contrast ? shirt.getShirtTitle() : shirt.getFabricName()}
        </div>
      </div>
    </div>
  )
};

export default Product